<template>
	<div class="message-action-menu">
		<button
			v-if="feedbackStatus !== -1"
			class="action-button"
			:class="{ active: feedbackStatus === 1 }"
			@click="handleThumbsUp"
			:disabled="isDisabled"
		>
			<InlineSvg src="/images/icons-2025/thumbs-up.svg" />
		</button>

		<button
			v-if="feedbackStatus !== 1"
			class="action-button"
			:class="{ active: feedbackStatus === -1 }"
			@click="handleThumbsDown"
			:disabled="isDisabled"
		>
			<InlineSvg src="/images/icons-2025/thumbs-down.svg" />
		</button>

		<button class="action-button" @click="handleRefresh" :disabled="isDisabled">
			<InlineSvg src="/images/icons-2025/refresh-02.svg" />
		</button>

		<button class="action-button" @click="handleCopy" :disabled="isDisabled">
			<InlineSvg v-if="!showCheckmark" src="/images/icons-2025/copy.svg" />
			<InlineSvg v-else src="/images/icons-2025/check.svg" />
		</button>
	</div>
</template>

<script>
	export default {
		name: 'MessageActionMenu',
		props: {
			message: {
				type: Object,
				required: true,
			},
			feedbackStatus: {
				type: Number,
				default: 0,
			},
			isDisabled: {
				type: Boolean,
				default: false,
			},
			showCheckmark: {
				type: Boolean,
				default: false,
			},
		},
		methods: {
			handleThumbsUp() {
				this.$emit('thumbs-up', this.message)
			},
			handleThumbsDown() {
				this.$emit('thumbs-down', this.message)
			},
			handleRefresh() {
				this.$emit('refresh', this.message)
			},
			handleCopy() {
				this.$emit('copy', this.message)
			},
		},
	}
</script>

<style lang="scss" scoped>
	.message-action-menu {
		display: flex;
		align-items: center;
		gap: 16px;
		margin-top: 8px;
		padding-left: 0; // Align with the message content
	}

	.action-button {
		background: none;
		border: none;
		padding: 0;
		border-radius: 6px;
		color: #6875a1;
		cursor: pointer;
		transition: all 0.2s ease;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20px;
		height: 20px;

		&:hover:not(:disabled) {
			background: #f3f4f6;
			color: #6875a1;
		}

		&:disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}

		&.active {
			color: #6355ff;
			background: #ebebff;
			border-radius: 8px;
			width: 28px;
			height: 28px;
			padding: 4px;
			margin: -4px;
			margin-left: 0px;
			box-shadow: 0 2px 4px rgba(99, 85, 255, 0.2);
		}

		svg {
			width: 20px;
			height: 20px;
		}

		:deep(svg path) {
			fill: #6875a1;
		}

		&.active :deep(svg path) {
			fill: #6355ff;
		}

		// Icon switching for thumbs up/down
		.no-feedback {
			display: block;
		}

		.chosen {
			display: none;
		}

		&.active {
			.no-feedback {
				display: none;
			}

			.chosen {
				display: block;
			}
		}
	}
</style>
